import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useProductIdParam } from './useProductIdParam'
import { useProductDocument } from './useProductDocument'

export const useProductById = (props?: Partial<UseDocumentProps>) => {
  let productId = useProductIdParam()

  //override the value of _id
  if (props?._id) {
    productId = props?._id
  }

  return useProductDocument({
    ...props,
    _id: productId,
  })
}
